var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElastic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    width: 52,
    height: 52,
    transform: "translate(396 2157)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(-396 -2157)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elasticsearch_logo",
    transform: "translate(384.322 2166.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19724",
    "data-name": "Path 19724",
    d: "M22.9,13.187H63.6v5.331H22.9Z",
    transform: "translate(0.082 0.221)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15830",
    "data-name": "Group 15830",
    transform: "translate(15.167 -7.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19738",
    "data-name": "Path 19738",
    d: "M28.416,14.859H15.554c.062.308.185.615.246.862a22.621,22.621,0,0,1,.8,4.616c.062.615.062,1.292.062,1.908s0,1.292-.062,1.908a22.62,22.62,0,0,1-.8,4.616c-.062.308-.185.615-.246.862H28.416a7.385,7.385,0,0,0,0-14.77Z",
    transform: "translate(5.432 2.373)",
    fill: "#00a9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19739",
    "data-name": "Path 19739",
    d: "M33.2,24.152c.062-.615.062-1.292.062-1.908s0-1.292-.062-1.908a22.62,22.62,0,0,0-.8-4.616c-.062-.308-.185-.615-.246-.862H12.275a24.38,24.38,0,0,0-1.108,7.385,24.38,24.38,0,0,0,1.108,7.385H32.153c.062-.308.185-.615.246-.862A22.62,22.62,0,0,0,33.2,24.152Z",
    transform: "translate(-11.167 2.373)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19740",
    "data-name": "Path 19740",
    d: "M38.517,18.461h-16A25.3,25.3,0,0,1,20.855,21.6a23.889,23.889,0,0,1-3.262,4.185c-.431.431-.862.8-1.292,1.231A24.487,24.487,0,0,1,13.47,29.17a24.355,24.355,0,0,0,13.539,4.062A24.669,24.669,0,0,0,47.5,22.277a12.551,12.551,0,0,0-8.985-3.816Z",
    transform: "translate(-2.453 16.003)",
    fill: "#00bfb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19741",
    "data-name": "Path 19741",
    d: "M27.962,21.6a25.3,25.3,0,0,0,1.662-3.139H11.591A24.334,24.334,0,0,0,20.638,29.17a31.219,31.219,0,0,0,2.831-2.154c.431-.369.862-.8,1.292-1.231a24.256,24.256,0,0,0,3.2-4.185Z",
    transform: "translate(-9.56 16.003)",
    fill: "#019b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19742",
    "data-name": "Path 19742",
    d: "M24.748,15.491c-.431-.431-.862-.8-1.292-1.231a24.486,24.486,0,0,0-2.831-2.154,25.159,25.159,0,0,0-9.047,10.708H29.61a25.3,25.3,0,0,0-1.662-3.139,19.354,19.354,0,0,0-3.2-4.185Z",
    transform: "translate(-9.609 -8.044)",
    fill: "#f9b110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19743",
    "data-name": "Path 19743",
    d: "M27.009,11.257A24.355,24.355,0,0,0,13.47,15.319,31.219,31.219,0,0,1,16.3,17.473c.431.369.862.8,1.292,1.231a23.889,23.889,0,0,1,3.262,4.185,25.3,25.3,0,0,1,1.662,3.139h16A12.552,12.552,0,0,0,47.5,22.211,24.669,24.669,0,0,0,27.009,11.257Z",
    transform: "translate(-2.453 -11.257)",
    fill: "#fed10a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElastic);
export default __webpack_public_path__ + "static/media/Elastic.d60f7c65ecda0dc81b04c30052c09bc4.svg";
export { ForwardRef as ReactComponent };